import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { listItemClasses, ListItem as ListItem$1 } from '@mui/material';
import { archerConstants } from '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import 'uuid/v4';
var _excluded = ["alignItems", "autoFocus", "button", "className", "onClick", "children", "dense", "disabled", "disableGutters", "divider", "selected", "dataProp", "onBlur", "onFocus", "onKeyUp", "onKeyDown", "id", "title", "sx"];

var _listItemHover;

var styles = {
  listItemHover: (_listItemHover = {}, _defineProperty(_listItemHover, "&.".concat(listItemClasses['button'], ":hover"), {
    backgroundColor: archerConstants.archerHover
  }), _defineProperty(_listItemHover, "&.".concat(listItemClasses['button'], ":active, &.").concat(listItemClasses['button'], ":focus"), {
    backgroundColor: "".concat(archerConstants.archerActive, " !important")
  }), _listItemHover)
};
var ListItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var alignItems = _ref.alignItems,
      autoFocus = _ref.autoFocus,
      button = _ref.button,
      className = _ref.className,
      onClick = _ref.onClick,
      children = _ref.children,
      dense = _ref.dense,
      disabled = _ref.disabled,
      disableGutters = _ref.disableGutters,
      divider = _ref.divider,
      selected = _ref.selected,
      dataProp = _ref.dataProp,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onKeyUp = _ref.onKeyUp,
      onKeyDown = _ref.onKeyDown,
      id = _ref.id,
      title = _ref.title,
      sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  var listItemHover = styles.listItemHover;
  return /*#__PURE__*/React.createElement(ListItem$1, _extends({
    alignItems: alignItems,
    autoFocus: autoFocus,
    button: button,
    onClick: onClick,
    className: className,
    sx: [listItemHover, sx],
    dense: dense,
    disabled: disabled,
    disableGutters: disableGutters,
    divider: divider,
    selected: selected,
    "data-selector": dataProp,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    id: id,
    title: title,
    ref: ref
  }, rest), children);
});
ListItem.displayName = 'ListItem';
export { ListItem };